import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useConsoleAuth } from "@/contexts/ConsoleAuthContext";

export default function ConsoleProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useConsoleAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="console-root grid h-screen place-items-center text-[13px] text-slate-400">
        <div className="console-ambient" aria-hidden />
        <span className="relative z-10">Loading console…</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/console/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
